module.exports = __webpack_public_path__ + "static/media/1.66d84de0.png";